import Icon from "@material-ui/icons/Person";
import LevelCreate from "./LevelCreate";
import LevelEdit from "./LevelEdit";
import LevelShow from "./LevelShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "levels",
  show: LevelShow,
  edit: LevelEdit,
  create: LevelCreate,
  icon: Icon,
};
